module.exports = __webpack_public_path__ + "static/img/1-0.57467f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/zoology/1-0.png
// module id = pOsj
// module chunks = 15